import { Finding, SourceLabel, SourceToColor } from "stores/FindingStore";

import { GenericObject } from "utility/misc";

// -----------------------------------------------------------------------------

export default function getPieData(findings: Finding[] = []) {
  let foundIdx: number;

  // Group all findings by source and keep track of count per source
  let pieData: PieDataProps[] = findings?.reduce<PieDataProps[]>(
    (accu, curr) => {
      if (
        accu.some((value, resIdx) => {
          // present in output array?
          foundIdx = resIdx;
          return value.source === curr.source;
        })
      ) {
        // already present, increment value
        accu[foundIdx].value++;
      } else {
        // not yet present, push the element with a count of one
        accu.push({
          id: SourceLabel[curr.source],
          label: SourceLabel[curr.source],
          value: 1,
          source: curr.source,
        });
      }
      return accu;
    },
    []
  );

  if (pieData.length > 6) {
    const above = [];
    const below: PieDataProps[] = [];

    for (const v of pieData) {
      if (v.value <= 10) {
        below.push(v);
        return;
      }
      above.push(v);
    }

    if (below.length > 1) {
      let otherCount = 0;
      for (const v of below) {
        otherCount += v.value;
      }

      above.push({
        id: "Other",
        label: "Other",
        value: otherCount,
        source: -1,
      });

      pieData = above;
    }
  }

  pieData.map((v, i) => {
    return (v.color = SourceToColor[v.source]);
  });

  return (pieData || []) as GenericObject[];
}

interface PieDataProps {
  id: string;
  label: string;
  value: number;
  source: number;
  color?: string;
}
